module.exports = __webpack_public_path__ + "assets/img/haiyun.6b7e7054.png";